<i18n>
{
	"en": {
		"selectOrderTypes": "Select order types",
		"orderTypesSelected": "All order types | {count} order type selected | {count} order types selected"
	},
	"no": {
		"selectOrderTypes": "Velg oppdragstyper",
		"orderTypesSelected": "Alle oppdragstyper | {count} oppdragstype valgt | {count} oppdragstyper valgt"
	}
}
</i18n>
<template>
	<t-select
		:items="orderTypes"
		:label="label"
		:selectedItems="selectedItems"
		:disabled="disabled"
		width="100%"
		displayName="name"
		v-bind="$attrs"
		relative
		@change="onChange"
	>
		<template #displayedValue="{popoverShow}">
			{{ popoverShow ? $t('selectOrderTypes') : $tc('orderTypesSelected', selectedItems.length) }}
		</template>
	</t-select>
</template>

<script>
import { mapState, mapActions } from './store/orderTypes.store';

export default {
	name: 'OrderTypesSelect',
	inheritAttrs: false,
	props: {
		label: String,
		selectedItems: Array
	},
	computed: {
		...mapState(['orderTypes']),
		disabled() {
			return !this.orderTypes || this.orderTypes.length === 0;
		}
	},
	mounted() {
		this.getOrderTypes();
	},
	methods: {
		...mapActions(['getOrderTypes']),
		onChange(event) {
			this.$emit('change', event);
		}
	}
};

</script>

<style lang="scss" scoped>

</style>
